/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import { Helmet } from "react-helmet"
import { withPrefix, useStaticQuery, graphql } from "gatsby"

function Seo({ title, description, url, image }) {
  
  const siteQuery = useStaticQuery(graphql`
    query SEO {
      site: datoCmsSite {
        globalSeo {
          facebookPageUrl
          fallbackSeo {
            description
            image {
              url
            }
            title
            twitterCard
          }
          siteName
          twitterAccount
        }
      }
    }
  `)

  
  const { globalSeo } = siteQuery.site
  return (
    <Helmet htmlAttributes={{ lang: "en" }}>
      <title>{title ? title : globalSeo.fallbackSeo.title}</title>
      <meta charSet="utf-8" />
      <meta
        name="description"
        content={description ? description : globalSeo.fallbackSeo.description}
      />
      <meta
        property="og:title"
        content={title ? title : globalSeo.fallbackSeo.title}
      />
      <meta
        property="og:description"
        content={description ? description : globalSeo.fallbackSeo.description}
      />
      <meta
        property="og:image"
        content={image ? image.url : globalSeo.fallbackSeo.image.url}
      />
      <meta property="og:type" content="website" />
      <meta
        property="og:url"
        content={url ? url : globalSeo?.og_data?.og_url}
      />

      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:site"
        content={
          globalSeo?.twitter_data?.twitter_account
            ? globalSeo?.twitter_data?.twitter_account
            : ""
        }
      />
      <meta
        name="twitter:title"
        content={title ? title : globalSeo?.og_data?.og_title}
      />
      <meta
        name="twitter:description"
        content={description ? description : globalSeo.fallbackSeo.description}
      />
      <meta
        name="twitter:image"
        content={image ? image.url : globalSeo.fallbackSeo.image.url}
      />
      {/* <!-- Global site tag (gtag.js) - Google Analytics --> */}
      <script async src="https://www.googletagmanager.com/gtag/js?id=G-J1MPG4MRV1"></script>
      <script>
        {
          `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());

          gtag('config', 'G-J1MPG4MRV1');
        `
        }
      </script>
  
    </Helmet>
  )
}

export default Seo
